class UrlParams {
    constructor(search) {
        this.qs = (search).substring(1);
        this.params = {};
        this.parseQueryString();
    }
    parseQueryString() {
        this.qs.split('&').reduce((a, b) => {
            const [key, val] = b.split(/=(.+)/g);
            if (!val) {
                a[key] = '';
                return a;
            }
            // For token parameter, just store as-is without encoding/decoding
            // The token might already be properly encoded for URL usage
            if (key === 'token') {
                a[key] = val;
            } else {
                // Keep the original behavior for other parameters
                a[key] = encodeURIComponent(val);
            }
            return a;
        }, this.params);
    }
    get(key) {
        return this.params[key];
    }
}
export default UrlParams